import script from "./STooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./STooltip.vue?vue&type=script&lang=ts&setup=true"

import "./STooltip.vue?vue&type=style&index=0&id=201a1787&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201a1787"]])

export default __exports__